import { Grid } from '@material-ui/core';
import { Text, Paper } from 'library';
import React, { useEffect, useState } from 'react';
import { getHiredProviders } from '../shared/api';
import { IHiredProvider } from '../models';
import ProviderHiredCard from './ProviderHiredCard';

export default function ProviderHires({ groupId }: { groupId: string | number }) {
    const [hiredProviders, setHiredProviders] = useState<IHiredProvider[]>();
    useEffect(() => {
        getHiredProviders(groupId, setHiredProviders);
    }, []);

    return hiredProviders && hiredProviders.length > 0 ? (
        <Paper style={{ marginBottom: 25 }}>
            <Grid xs={12} container item direction="column">
                <Text bold variant="h2" textStyle={{ paddingBottom: 25 }}>
                    Recently Hired Poviders:
                </Text>
                <Grid container item>
                    <div style={{ display: 'inline-flex', overflowX: 'scroll', paddingBottom: 10 }}>
                        {hiredProviders.map((hiredProvider: IHiredProvider) => (
                            <ProviderHiredCard hiredProvider={hiredProvider} />
                        ))}
                    </div>
                </Grid>
            </Grid>
        </Paper>
    ) : (
        <></>
    );
}
